/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Leadership_Advisor_BioInputs */

const en_landing_leadership_advisor_bio = /** @type {(inputs: Landing_Leadership_Advisor_BioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bev is the former Chairman & CEO of Aberdeen Asset Management Americas, having built the business from day zero in the 1990s. He provides institutional oversight and strategic guidance, ensuring our infrastructure meets the highest standards of global institutional finance.`)
};

/**
* | output |
* | --- |
* | "Bev is the former Chairman & CEO of Aberdeen Asset Management Americas, having built the business from day zero in the 1990s. He provides institutional overs..." |
*
* @param {Landing_Leadership_Advisor_BioInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_leadership_advisor_bio = /** @type {((inputs?: Landing_Leadership_Advisor_BioInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Leadership_Advisor_BioInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_leadership_advisor_bio(inputs)
});